export default __webpack_public_path__ + "static/media/loader-review2.66c1333f.svg";